module.exports = __webpack_public_path__ + "static/img/home_v8.d03f112.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/TopBar/home_v8.svg
// module id = fnfN
// module chunks = 0